import React from 'react';
import styled from 'styled-components';

import ButtonUI from '@catalogo/ui-americanas-desktop-button';

const NotFoundTerm = React.memo(({ productId, brandText }) => (
  <Wrapper>
    <Message>
      <h6>{brandText.termNotFound.title}</h6>
      <span>{brandText.termNotFound.subtitle}</span>
    </Message>
    <List>
      <li>{brandText.termNotFound.suggestions.hintOne}</li>
      <li>{brandText.termNotFound.suggestions.hintTwo}</li>
    </List>
    <Button href={`/perguntar/${productId}`} title="Escrever pergunta" />
  </Wrapper>
));

const Wrapper = styled.div`
  text-align: left;
  font-weight: normal;
  font-size: 16px;
  line-height: 26px;
  color: #666666;
`;

const Message = styled.div`
  > h6 {
    font-weight: bold;
    font-size: 18px;
    line-height: 26px;
    color: #666666;
    margin-bottom: 20px;
  }
`;

const List = styled.ul`
  margin: 4px 0;

  > li {
    margin: 4px 0;
    list-style: disc;
    list-style-position: inside;
  }
`;

const Button = styled(ButtonUI)`
  color: ${({ theme }) => theme.primaryColor};
  font-weight: bold;
  font-size: 16px;
  line-height: 26px;
  background: none;
  border: none;
  outline: none;
  margin: 4px 0;
  padding: 0;
  justify-content: left;
  text-transform: ${({ theme }) => theme.btnTextTransform};
  cursor: pointer;

  & :hover {
    color: ${({ theme }) => theme.primaryColor};
  }
`;

export default NotFoundTerm;
